import { render, staticRenderFns } from "./BootMachineDemo.vue?vue&type=template&id=31221edf&"
import script from "@/scripts/modal/rentalService/bootMachineDemo.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/rentalService/bootMachineDemo.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports